import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

function TopRightMenu({ ambientOn = false, setAmbientOn = () => {} }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const location = useLocation();
  const isRequestDemoLanding = location.pathname === '/request-demo-class';

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (isRequestDemoLanding) return null;

  return (
    <div style={{ position: 'absolute', top: '1rem', right: '1rem', zIndex: 999 }} ref={menuRef}>
      {/* Hamburger icon */}
      <div
        onClick={() => setOpen(!open)}
        style={{
          cursor: 'pointer',
          width: '30px',
          height: '20px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
      >
        <div style={{ height: '4px', background: '#333', borderRadius: '2px' }}></div>
        <div style={{ height: '4px', background: '#333', borderRadius: '2px' }}></div>
        <div style={{ height: '4px', background: '#333', borderRadius: '2px' }}></div>
      </div>

      {open && (
        <div style={{
          position: 'absolute',
          top: '40px',
          right: '0',
          background: '#fff',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          padding: '10px',
          borderRadius: '5px',
          textAlign: 'right',
          minWidth: '150px',
          zIndex: 1000
        }}>
          <Link to="/about" onClick={() => setOpen(false)} style={{ display: 'block', marginBottom: '10px', color: '#333' }}>About</Link>
          <Link to="/features" onClick={() => setOpen(false)} style={{ display: 'block', marginBottom: '10px', color: '#333' }}>Features</Link>
          <Link to="/privacy-policy" onClick={() => setOpen(false)} style={{ display: 'block', marginBottom: '10px', color: '#333' }}>Privacy Policy</Link>
          <Link to="/terms-of-use" onClick={() => setOpen(false)} style={{ display: 'block', marginBottom: '10px', color: '#333' }}>Terms of Use</Link>
          <a href="mailto:support@tutororca.com" onClick={() => setOpen(false)} style={{ display: 'block', color: '#333' }}>Help</a>
        </div>
      )}
    </div>
  );
}

export default TopRightMenu;
